import { styled } from "@mui/material/styles";
import DashboardContentWrapper from "./dashboardContentWrapper";
import ProfilePicture from "../assets/defaultImg.jpg";
import { useEffect, useState } from "preact/hooks";
import { getSessionStorage, validateName } from "../utils";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { Button } from "@mui/material";
import { Fragment } from "preact";
import BasicModal from "./common/basicModal";
import ChangePassword from "./changePassword";
import StarRateIcon from "@mui/icons-material/StarRate";
import { Edit } from "@mui/icons-material";
import { Link } from "preact-router";
import useApi from "../hooks/useApi";
import { profileApi, profileUpdateApi } from "../api/controller/accounts";

const Container = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 30px;
  .userProfilePicture {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 27.778vw;
    max-width: 400px;
  }
  .image {
    width: 27.778vw;
    height: 27.778vw;
    max-width: 300px;
    max-height: 300px;
    border-radius: 999px;
    // box-shadow: 0px 0px 5px rgba(196, 196, 196, 0.5);
    border: #c4c4c4 1px solid;
    margin-bottom: 12px;
  }
  .headerText {
    color: #f7f7f7;
    font-size: 36px;
    font-weight: 700;
    line-height: 48px;
    text-align: center;
  }
  .subText {
    color: #f7f7f7;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
    margin-top: 5px;
    width: max-content;
  }
  .continueWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0;
  }
  .line {
    width: 13.889vw;
    height: 2px;
    background-color: #f7f7f7;
    border-radius: 2px;
    margin: 10px 0;
  }
  .inputWrapper {
    display: flex;
    flex-direction: unset;
    align-items: center;
    justify-content: center;
    width: 41.667vw !important;
    max-width: 600px;
  }
  .usernameInputField1 {
    margin-right: 1.111vw;
    width: 20.347vw !important;
    height: 56px !important;
    margin-top: 15px;
  }
  .usernameInputField2 {
    width: 20.347vw !important;
    height: 56px !important;
    margin-top: 15px;
  }
  .loginButton {
    background-color: #6741d9;
    height: 60px;
    width: 41.667vw;
    max-width: 600px;
    margin-top: 35px;
    min-width: 250px;
    text-transform: none;
    padding: 0px 8px;
    border: 0;
    box-sizing: border-box;
    border-radius: 16px;
    box-shadow: -1px 1px 10px #f0c3f1;
    background-color: #6741d9;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    outline: none;
    font-family: Poppins;
  }
  .loginButton:hover {
    border: #f0c3f1 1px solid;
    background-color: #6741d9;
  }
  .loginButton:disabled {
    background-color: #808080;
    color: #000000;
  }
  .inputField {
    width: 41.667vw !important;
    max-width: 600px;
    height: 56px !important;
    margin-top: 35px;
  }
  .continueText {
    margin: 0px 6.25vw;
    color: #f7f7f7;
    font-size: 16px;
    font-style: Italic;
  }
  .changePassword {
    background-color: #fff;
    height: 60px;
    color: black;
    font-weight: 600;
    width: 41.667vw;
    max-width: 600px;
    border-radius: 16px;
    margin-bottom: 20px;
    text-decoration: none;
  }
  .changePassword:hover {
    border: #f0c3f1 1px solid;
    background-color: #fff;
  }
  .userData {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .userProfileData {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .userAction {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .continueLine {
    width: 10vw;
    height: 1px;
    background-color: #f7f7f7;
    border-radius: 2px;
    margin: 10px 0;
  }
  .floating-bar {
    width: 100%;
    height: 1px;
    background-color: #f7f7f7;
    border-radius: 1px;
    align-items: center;
    justify-content: center;
  }
  @media only screen and (min-width: 600px) and (max-width: 800px) {
    flex-direction: column;
    .inputWrapper {
      width: 60vw !important;
      max-width: 600px;
    }
    .inputField {
      width: 60vw !important;
      max-width: 600px;
    }
    .usernameInputField1 {
      width: 90vw !important;
    }
    .usernameInputField2 {
      width: 90vw !important;
    }
    .loginButton {
      width: 60vw !important;
      max-width: 600px;
    }
    .changePassword {
      width: 60vw !important;
      max-width: 600px;
    }
  }
  @media only screen and (max-width: 724px) {
    flex-direction: column;
    .userData {
      padding-top: 20px;
    }
    .userProfilePicture {
      width: 90vw !important;
      max-width: 400px;
    }
    .line {
      width: 41.667vw !important;
    }
    .inputWrapper {
      width: 90vw !important;
    }
    .usernameInputField1 {
      width: 90vw !important;
    }
    .usernameInputField2 {
      width: 90vw !important;
    }
    .loginButton {
      width: 90vw !important;
      max-width: unset;
    }
    .changePassword {
      width: 90vw !important;
      max-width: unset;
      justify-content: center;
      align-items: center;
    }
    .inputField {
      width: 90vw !important;
      max-width: unset;
    }
  }
`;

const WhiteBorderTextField = styled(TextField)`
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: #FFF !important;
      border-radius: 8px;
    },
    &.Mui-focused fieldset {
      border-color: #FFF !important;
    },
  },
`;

function Profile() {
  const [hostName, setHostName] = useState();
  const [instaHandle, setInstaHandle] = useState();
  const [openSaveModal, setOpenSaveModal] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [instaPic, setInstaPic] = useState();

  const [profileData, setProfileData] = useState();

  const profileApiRequest = useApi();
  const profileUpdateApiRequest = useApi();

  useEffect(() => {
    profileApi(profileApiRequest.request, getSessionStorage("host"));
  }, []);

  useEffect(() => {
    if (profileApiRequest.data && profileApiRequest.data.data) {
      console.log("profile", profileApiRequest.data.data);
      setProfileData(profileApiRequest.data.data);
      setHostName(profileApiRequest.data?.data?.name);
      setInstaHandle(profileApiRequest.data?.data?.insta_handle);
      setInstaPic(profileApiRequest.data?.data?.insta_profile_pic);
    }
  }, [profileApiRequest.data]);

  const saveProfileData = () => {
    setOpenSaveModal(true);
  };

  const handleSaveModalClose = () => {
    setOpenSaveModal(false);
  };

  const handlePasswordChange = (value) => {
    setChangePassword(value);
  };

  const getButtonColor = (rating) => {
    if (rating == 0) {
      return " #c1c1c1";
    } else if (rating < 2) {
      return "#ef4f5f";
    } else if (rating < 3.5) {
      return "#cdb936";
    } else {
      return "#286e34";
    }
  };

  useEffect(() => {
    if (profileUpdateApiRequest.data) {
      setOpenSaveModal(false);
      profileApi(profileApiRequest.request, getSessionStorage("host"));
    }
  }, [profileUpdateApiRequest.data]);

  const handleEdit = () => {
    const data = {
      ...(hostName !== profileData.name && { name: hostName }),

      ...(instaHandle !== profileData.insta_handle && {
        insta_handle: instaHandle?.length > 1 ? instaHandle : null,
      }),

      ...(instaPic !== profileData.instaPic && {
        insta_profile_pic: instaPic,
      }),
    };
    profileUpdateApi(
      profileUpdateApiRequest.request,
      getSessionStorage("host"),
      data
    );
  };

  return (
    <Fragment>
      {changePassword ? (
        <ChangePassword />
      ) : (
        <DashboardContentWrapper>
          {!profileData || profileApiRequest.loading ? (
            <div>Loading...</div>
          ) : (
            <Container>
              <div className="userProfilePicture">
                <img
                  src={instaPic ?? ProfilePicture}
                  alt=""
                  className="image"
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <div className="subText">
                    Total song requests : {profileData?.total_requests}
                  </div>
                  <div
                    style={{
                      display: "Flex",
                      width: "100%",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Link
                      href={"/review-page/"}
                      className="ratingText"
                      style={{
                        display: "Flex",
                        width: "100%",
                        gap: "10px",
                        justifyContent: "center",
                        alignItems: "center",
                        textDecoration: "none",
                      }}
                    >
                      <Button
                        // className="ratingButton"
                        style={{
                          width: "52px",
                          height: "32px",
                          borderRadius: "5px",
                          color: "white",
                          backgroundColor: getButtonColor(profileData.rating),
                          fontFamily: "poppins",
                          display: "flex",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "16px",
                            fontFamily: "Poppins",
                            textDecoration: "none",
                          }}
                        >
                          {profileData?.rating > 0 ? profileData.rating : "-  "}{" "}
                        </span>
                        <StarRateIcon
                          style={{
                            height: "18px",
                            width: "18px",
                            paddingBottom: "2px",
                          }}
                        />
                      </Button>
                      <div>
                        <div className="subText">Check all reviews</div>
                        <div className="floating-bar"></div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="userData">
                <div className="userProfileData">
                  <div className="headerText">Profile</div>
                  <div className="inputWrapper">
                    <WhiteBorderTextField
                      className="inputField"
                      sx={{ input: { color: "white", fontFamily: "poppins" } }}
                      label="Username"
                      InputLabelProps={{
                        style: {
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          width: "100%",
                          color: "#808080",
                        },
                      }}
                      InputProps={{
                        readOnly: true,
                        style: {
                          borderColor: "#808080",
                          pointerEvents: "none",
                        },
                      }}
                      id="username"
                      autoComplete="off"
                      style={{
                        width: "100% !important",
                        marginTop: "30px",
                      }}
                      placeholder="Username"
                      variant="outlined"
                      // onChange={(e) => {
                      //   setUsername({ name: validateName(e.target.value) });
                      // }}
                      value={profileData?.username}
                    />
                  </div>
                  <div className="inputWrapper">
                    <WhiteBorderTextField
                      className="inputField"
                      sx={{ input: { color: "white", fontFamily: "poppins" } }}
                      label="Name"
                      InputLabelProps={{
                        style: {
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          width: "100%",
                          color: "#808080",
                        },
                      }}
                      id="name"
                      autoComplete="off"
                      style={{ width: "100%", marginTop: "30px" }}
                      placeholder="Name"
                      variant="outlined"
                      onChange={(e) => {
                        setHostName(validateName(e.target.value));
                      }}
                      value={hostName}
                    />
                  </div>

                  <div className="inputWrapper">
                    <WhiteBorderTextField
                      className="inputField"
                      sx={{ input: { color: "white", fontFamily: "poppins" } }}
                      label="Instagram"
                      InputLabelProps={{
                        style: {
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          width: "100%",
                          color: "#808080",
                        },
                      }}
                      id="instagram"
                      autoComplete="on"
                      style={{ width: "100%", marginTop: "30px" }}
                      placeholder="Instagram"
                      variant="outlined"
                      onChange={(e) => {
                        setInstaHandle(e.target.value);
                      }}
                      value={instaHandle}
                    />
                  </div>
                </div>
                <div className="userAction">
                  <Button
                    className="loginButton"
                    disabled={
                      hostName?.length < 1 ||
                      // instaHandle?.length < 1 ||
                      (hostName === profileData.name &&
                        instaHandle === profileData.insta_handle)
                    }
                    onClick={() => {
                      saveProfileData();
                      handleEdit();
                    }}
                  >
                    Save
                  </Button>
                  <div className="continueWrapper">
                    <div className="continueLine" />
                    <div className="continueText">OR</div>
                    <div className="continueLine" />
                  </div>
                  <Link
                    href={"/change-password/"}
                    className="changePassword"
                    onClick={() => {
                      handlePasswordChange(true);
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        height: "100%",
                        display: "flex",
                      }}
                    >
                      Change Password
                    </div>
                  </Link>
                  <div></div>
                </div>
              </div>
            </Container>
          )}
          {/* <BasicModal open={openSaveModal} handleClose={handleSaveModalClose}>
            <div className="modalHeaderText">Noted!</div>
            <div className="modalSubText">
              New Email and Phone Number will be updated post verification.
            </div>
            <Button
              className="modalButton"
              onClick={() => {
                handleEdit();
              }}
            >
              Got it!
            </Button>
          </BasicModal> */}
        </DashboardContentWrapper>
      )}
    </Fragment>
  );
}

export default Profile;
